import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { Http, XHRBackend, ConnectionBackend, RequestOptions } from '@angular/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouteReusableStrategy } from './route-reusable-strategy';
import { AuthenticationService } from './authentication/authentication.service';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { I18nService } from './i18n.service';
import { HttpService } from './http/http.service';
import { HttpCacheService } from './http/http-cache.service';
import { WalletService } from '@app/core/wallet.service';
import { UserProfileService } from '@app/core/user-profile.service';
import { SocketService } from '@app/core/socket.service';
import { EtherInterfaceService } from '@app/core/ether-interface.service';
import { HttpClientModule } from '@angular/common/http';
import { PusherService } from '@app/core/pusher.service';
import { SeedService } from '@app/core/seed.service';
import { ErrorManagerService } from '@app/core/error-manager.service';
import { SoundsService } from '@app/core/sounds.service';
import { RandomUsernameService } from '@app/core/random-username.service';
import { PlayerStatsService } from '@app/core/player-stats.service';
import { IntercomService } from '@app/core/intercom.service';
import { VipMemberGuard } from '@app/core/vip-member.guard';
import { GasService } from '@app/core/gas.service';
import { StateChannelService } from '@app/core/state-channel.service';
import { SmartAlertService } from '@app/core/smart-alert.service';
import { MultiplaySocketService } from '@app/core/multiplay-socket.service';
import { NotificationsService } from '@app/core/notifications.service';
import { AffiliateService } from '@app/core/affiliate.service';
import { WithdrawService } from '@app/core/account/withdraw.service';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
import { ShapeShiftService } from '@app/core/account/shape-shift.service';
import { FiatService } from '@app/core/account/fiat.service';
import { AlertService } from '@app/core/alert.service';
import { OnlyGuestGuard } from '@app/core/authentication/only-guest.guard';
import { JackpotService } from '@app/core/jackpot.service';
import { ExplorerLinkerService } from '@app/core/explorer-linker.service';
import { DepositService } from '@app/core/account/deposit.service';
import { GamesService } from '@app/core/games.service';
import { WagerService } from '@app/core/wager.service';
import { BonusService } from '@app/core/bonus.service';
import { BonusCodesService } from '@app/core/bonus-codes.service';
import { AppService } from '@app/core/app.service';
import { BettingService } from '@app/core/betting.service';
import { BettingSocketService } from '@app/core/betting-socket.service';
import { HammerConfig } from '@app/core/hammer.config';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BalanceService } from '@app/core/balance.service';
import { AuthenticationWithUserGuard } from '@app/core/authentication/authentication-with-user.guard';
import { ContentService } from '@app/core/content.service';

export function createHttpService(
  backend: ConnectionBackend,
  defaultOptions: RequestOptions,
  httpCacheService: HttpCacheService
) {
  return new HttpService(backend, defaultOptions, httpCacheService);
}

@NgModule({
  imports: [
    CommonModule,
    // HttpModule,
    HttpClientModule,
    TranslateModule,
    NgbModule,
    RouterModule,
    // SharedModule,
  ],
  exports: [],
  declarations: [],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    AuthenticationWithUserGuard,
    OnlyGuestGuard,
    VipMemberGuard,
    I18nService,
    HttpCacheService,
    WalletService,
    UserProfileService,
    SocketService,
    MultiplaySocketService,
    EtherInterfaceService,
    PusherService,
    SeedService,
    ErrorManagerService,
    SoundsService,
    RandomUsernameService,
    PlayerStatsService,
    IntercomService,
    GasService,
    StateChannelService,
    SmartAlertService,
    NotificationsService,
    AffiliateService,
    ShapeShiftService,
    WithdrawService,
    DepositService,
    BalanceHistoryService,
    FiatService,
    AlertService,
    JackpotService,
    ExplorerLinkerService,
    WagerService,
    GamesService,
    BonusService,
    BonusCodesService,
    BettingService,
    BettingSocketService,
    AppService,
    ContentService,
    BalanceService,
    {
      provide: Http,
      deps: [XHRBackend, RequestOptions, HttpCacheService],
      useFactory: createHttpService,
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    {
      // hammer instantion with custom config
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/core.module.ts